import apiServices from 'config/apiServiceApiGateway'

const { Get, Post } = apiServices

export type GetAllSegmentsResponseType = {
  name: string
  id: number
  total_user: number
}[]

export const getAllSegments = () =>
  Get<GetAllSegmentsResponseType>({ url: `/segmentation/internal/v1/segment` })

// Preserve both legacy payload branches, including null segmentation metadata.
export type CampaignInventoryDiscountRequestType = {
  product_id: number
  location_id: number
  segment_id: string | number | null
  segment_name: string | null
} & ({ user_segment: string; userSegment?: never } | { userSegment: ''; user_segment?: never })

export type PostAddCampaignInventoryRequestType = {
  id: string | null
  payload: {
    inventory_discount_list: CampaignInventoryDiscountRequestType[]
    source: 'admin'
  }
}

export const postAddCampaignInventory = ({ id, payload }: PostAddCampaignInventoryRequestType) =>
  Post({ url: `/campaign/internal/v1/${id}/add-inventory`, data: payload })
